export default __webpack_public_path__ + "static/media/launch_checkmark.0cfe920a.svg";